module.exports = __webpack_public_path__ + "img/IMG_2288.9097a7af.jpg";